import { Component, OnInit,  ViewChild ,ElementRef} from '@angular/core';
import { DashboardService } from '../service/dashboard.service';
import { Router } from '@angular/router';
import { MatTableDataSource, MatPaginator ,MAT_DATE_FORMATS, DateAdapter, MatDialog} from '@angular/material';


import { FormControl } from '@angular/forms';


import { MatDateFormats, MAT_NATIVE_DATE_FORMATS } from '@angular/material';
// import Swal, { SweetAlertResult } from 'sweetalert2';
import { QuoteSummaryComponent } from 'src/app/dialogs/quote-summary/quote-summary.component';
import * as XLSX from 'xlsx'; 
import { ExportExcel } from '../service/export';


import Swal, { SweetAlertOptions, SweetAlertResult } from 'sweetalert2';


export const GRI_DATE_FORMATS: MatDateFormats = {
  ...MAT_NATIVE_DATE_FORMATS,
  display: {
    ...MAT_NATIVE_DATE_FORMATS.display,
    dateInput: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    } as Intl.DateTimeFormatOptions,
  }
};
@Component({
  selector: 'app-policylistings',
  templateUrl: './policylistings.component.html',
  styleUrls: ['./policylistings.component.scss'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: GRI_DATE_FORMATS },
  ]
})

export class PolicylistingsComponent implements OnInit {

  userdata;
  allpolicies:any=[];
  searchdata;


  minDate: Date;
  maxDate: Date;

  startDate :any
  endDate  : any

  length: number;
  pageSize: number= 10;
  pageSizeOptions = [ 10, 20,50,100];

  @ViewChild(MatPaginator) paginator: MatPaginator;



  fileName= 'Policy.xlsx';

  exportActive:boolean = false;

  // @ViewChild('TABLE') table: ElementRef;



  dataSource = new MatTableDataSource();
  // columnDefinitions = [
  //   { def: 'id', label: 'ID', hide: this.id.value},
  //   { def: 'description', label: 'Description', hide: false}
  // ]



 // displayedColumns = ['no','BRANCH',  'AGENT_NAME' ,'CUSTOMER_FIRST_NAME', 'CUSTOMER_PHONE',  'RISK_DESCRIPTION','VEHICLE_REGISTRATION','CHANNEL','COST_OF_INSURANCE','DURATION_TYPE','STATUS','TRANSACTION_DATE','link'];


  displayedColumns = ['POLICY_SEQUENCE', 'CUSTOMER_FIRST_NAME', 'CUSTOMER_PHONE',  'PRODUCT_DESCRIPTION' , 'RISK_DESCRIPTION','VEHICLE_REGISTRATION','CHANNEL','COST_OF_INSURANCE','DURATION_TYPE','INCEPTION_DATE','EXPIRY_DATE','view', 'cancel'];


  constructor(public service:DashboardService, public router:Router,private readonly adapter: DateAdapter<Date>,private dialog :MatDialog) {

    const currentYear = new Date().getFullYear();
    this.minDate = new Date(currentYear - 2, 0, 1);
    // this.maxDate = new Date(currentYear + 1, 11, 31);
    this.maxDate = new Date(currentYear + 1, 0, 0);
   }


  date = new FormControl(new Date(new Date().setDate(new Date().getDate() - 30)));

  serializedDate = new FormControl((new Date()).toISOString().substring(0,10))

  ngOnInit() {

    this.userdata=JSON.parse(localStorage.getItem('userdata'))


    var today = new Date(); //get todays date
    this.endDate= today.toISOString().substring(0,10) //convert todays date to format eg.2019-08.02 and set it to end date

    today.setDate(today.getDate() - 30) // subtract 7 days from todays date
    this.startDate = today.toISOString().substring(0,10)

    Swal.showLoading();;
    this.service.getAllpolicies({email:this.userdata.email, role :this.userdata.role ,minDate: this.startDate, maxDate : this.endDate}).subscribe(data=>{
      this.allpolicies = data['responseData'];

      this.dataSource.data = this.allpolicies;
      this.dataSource.paginator = this.paginator;

     Swal.close();
  })
  }


  openDetailsDialog(policy_number: string){
    const dialogRef = this.dialog.open(QuoteSummaryComponent, {
      disableClose :true,
      width: '500px',
      data: { quote: this.allpolicies.find(m=>m.POLICY_SEQUENCE==policy_number)}
    });

    dialogRef.afterClosed().subscribe(result => {});
  }

  find(){
    //email:this.ud.email,minDate:this.topperformstartdate,maxDate:this.topperformenddate,duration:days.toString(), role:this.ud.role}
    Swal.showLoading();;
    this.service.getAllpolicies({email:this.userdata.email, role :this.userdata.role ,minDate: this.startDate, maxDate : this.endDate}).subscribe(data=>{
      this.allpolicies = data['responseData'];


      this.dataSource.data = this.allpolicies;
      this.dataSource.paginator = this.paginator;
      Swal.close();
    })


  }



  updateDate1(dateObject) {
    // convert object to string then trim it to yyyy-mm-dd
    const stringified = JSON.stringify(dateObject.value);
    this.startDate = stringified.substring(1, 11);
    // this.applicant.contact[0].dob = dob;

    console.log(this.startDate )
  }


  updateDate2(dateObject) {
    // convert object to string then trim it to yyyy-mm-dd
    const stringified = JSON.stringify(dateObject.value);
    this.endDate = stringified.substring(1, 11);
    // this.applicant.contact[0].dob = dob;

    console.log("end date " + this.endDate )
  }


  cancelPolicy(policy_sequence: string, policy_lob: string) {
    console.log("policy_sequence ===> " + policy_sequence)
    console.log('policy_lob ===>', policy_lob);

    (Swal as any).fire({
      title: '',
      text: 'Do you want to cancel this policy? This cannot be undone!.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, proceed',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
    })
      .then((result: SweetAlertResult) => {
        if (result.value) {
          const requestPayload = {
            policy_sequence: policy_sequence,
            policy_lob : policy_lob
          }

          this.service.cancelPolicy(requestPayload)
            .toPromise()
            .then((data: any) => {
              Swal.close();

              if (data.hasOwnProperty('responseCode') && data.responseCode === '000') {
                (Swal as any).fire({
                  title: '',
                  text: 'Policy cancelled',
                  icon: 'success',
                })
                  .then((result: SweetAlertResult) => {
                    if (result.value) {
                      Swal.showLoading();
                      this.find()
                    }
                  })

              } else {
                (Swal as any).fire({
                  title: '',
                  text: data.responseMessage,
                  icon: 'error',
                });
              }

            }).catch(error => {
              (Swal as any).fire({
                title: 'Connection Failed!',
                text: 'Failed to cancel policy',
                icon: 'error',
              });
            })

        } else {
          result.dismiss === Swal.DismissReason.cancel
        }

      })


  }

  // cancelPolicy(policy_sequence: string, policy_lob: string): void {
  //   console.log("policy_sequence ===> ", policy_sequence);
  //   console.log("policy_lob ===> ", policy_lob);
  
  //   (Swal as any).fire({
  //     title: '',
  //     text: 'Do you want to cancel this policy?',
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonText: 'Yes, proceed',
  //     cancelButtonText: 'No, cancel!',
  //     reverseButtons: true,
  //     allowOutsideClick: false,
  //     allowEscapeKey: false
  //   }).then((result: SweetAlertResult) => {
  //     if (result.isConfirmed) {
  //       const requestPayload = {
  //         policy_sequence,
  //         policy_lob
  //       };
  
  //       const loadingOptions: SweetAlertOptions = {
  //         title: 'Cancelling policy...',
  //         allowOutsideClick: false,
  //         didOpen: () => {
  //           Swal.showLoading();;
  //         }
  //       };
  
  //       Swal.fire(loadingOptions);  // ✅ Type-safe and correct
  
  //       this.service.cancelPolicy(requestPayload)
  //         .toPromise()
  //         .then((data: any) => {
  //           if (data?.responseCode === '000') {
  //             (Swal as any).fire({
  //               title: '',
  //               text: 'Policy cancelled successfully',
  //               icon: 'success'
  //             }).then((result: SweetAlertResult) => {
  //               if (result.isConfirmed) {
  //                 const refetchLoadingOptions: SweetAlertOptions = {
  //                   title: 'Loading...',
  //                   allowOutsideClick: false,
  //                   didOpen: () => {
  //                     Swal.showLoading();;
  //                   }
  //                 };
  //                 Swal.fire(refetchLoadingOptions);
  //                 this.find();
  //               }
  //             });
  //           } else {
  //             (Swal as any).fire({
  //               title: 'Cancellation Failed',
  //               text: data?.responseMessage || 'Unknown error occurred',
  //               icon: 'error'
  //             });
  //           }
  //         })
  //         .catch((error) => {
  //           (Swal as any).fire({
  //             title: 'Connection Failed!',
  //             text: 'An error occurred while cancelling the policy.',
  //             icon: 'error'
  //           });
  //         });
  
  //     } else if (result.dismiss === Swal.DismissReason.cancel) {
  //       console.log("User cancelled policy cancellation.");
  //     }
  //   });
  // }
  









  exportexcel(){

    console.log("dwggw")

       /* table id is passed over here */   
      //  let element = document.getElementById('tableMain'); 
      //  const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

      //  /* generate workbook and add the worksheet */
      //  const wb: XLSX.WorkBook = XLSX.utils.book_new();
      //  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      //  /* save to file */
      //  XLSX.writeFile(wb, this.fileName);



      ExportExcel.exportTableToExcel("PolicyTable");

  }

  search (query: string){
    this.searchdata = (query) ?this.allpolicies.filter( data => data.manager_id.toLowerCase().includes(query.toLowerCase()) ||data.lastName.toLowerCase().includes(query.toLowerCase()) || data.firstName.toLowerCase().includes(query.toLowerCase()) || data.email.toUpperCase().includes(query.toUpperCase())) : this.allpolicies;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  Cusinfo(){
    this.router.navigate(['/customers'])
  }

  Transactions(){
    this.router.navigate(['/transactions'])
  }


  newclient(){
    this.router.navigate(['/newcustomer']);
      }

    Policylists(){
      this.router.navigate(['/policylistings'])
    }

    stickerlistings(){
      this.router.navigate(['/stickerlistings']);
    }


}
